export const popoverAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

export const popoverTransformOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

export const popoverSlotProps = {
  paper: {
    sx: {
      width: '420px',
      top: '60px !important',
      overflow: 'hidden',
    },
  },
};

export const drawerPaperProps = {
  sx: {
    width: '100vw',
    overflow: 'hidden',
  },
};
